/**
 * Simple encryption utility for API keys
 * Note: This is a basic implementation for demo purposes.
 * For production, use a proper encryption library and secure key management.
 */
const ENCRYPTION_KEY = 'demo-control-panel-key-2024'; // In production, use env variable
export class Encryption {
    /**
     * Simple XOR encryption for demo purposes
     * DO NOT use this in production - use proper encryption libraries
     */
    static encrypt(text) {
        if (!text)
            return '';
        let encrypted = '';
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
            encrypted += String.fromCharCode(charCode);
        }
        // Convert to base64 for storage
        return btoa(encrypted);
    }
    /**
     * Decrypt XOR encrypted text
     */
    static decrypt(encrypted) {
        if (!encrypted)
            return '';
        try {
            // Decode from base64
            const decoded = atob(encrypted);
            let decrypted = '';
            for (let i = 0; i < decoded.length; i++) {
                const charCode = decoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
                decrypted += String.fromCharCode(charCode);
            }
            return decrypted;
        }
        catch (error) {
            console.error('Failed to decrypt:', error);
            return '';
        }
    }
    /**
     * Encrypt an object containing API keys
     */
    static encryptApiKeys(apiKeys) {
        const encrypted = {};
        for (const [provider, keys] of Object.entries(apiKeys)) {
            if (keys && typeof keys === 'object') {
                encrypted[provider] = {};
                for (const [field, value] of Object.entries(keys)) {
                    if (typeof value === 'string') {
                        // Only encrypt sensitive fields
                        const sensitiveFields = ['apiKey', 'storefrontToken', 'siteKey'];
                        encrypted[provider][field] = sensitiveFields.includes(field)
                            ? this.encrypt(value)
                            : value;
                    }
                }
            }
        }
        return encrypted;
    }
    /**
     * Decrypt an object containing encrypted API keys
     */
    static decryptApiKeys(encryptedKeys) {
        const decrypted = {};
        for (const [provider, keys] of Object.entries(encryptedKeys)) {
            if (keys && typeof keys === 'object') {
                decrypted[provider] = {};
                for (const [field, value] of Object.entries(keys)) {
                    if (typeof value === 'string') {
                        // Only decrypt sensitive fields
                        const sensitiveFields = ['apiKey', 'storefrontToken', 'siteKey'];
                        decrypted[provider][field] = sensitiveFields.includes(field)
                            ? this.decrypt(value)
                            : value;
                    }
                }
            }
        }
        return decrypted;
    }
}
